/**
 * Step 4 - Review & Publish Component
 */

import React from 'react';
import Icon from '../../../components/AppIcon';
import { EXPERIENCE_LEVELS } from '../constants';

export const Step4ReviewPublish = React.memo(({ jobData }) => {
  const getExperienceLevelLabel = (value) => {
    const level = EXPERIENCE_LEVELS.find(l => l.value === value);
    return level ? level.label : value;
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Review & Publish
        </h3>

        <div className="bg-secondary-50 rounded-lg p-6 space-y-4">
          <div className="flex items-center justify-between">
            <h4 className="font-semibold text-text-primary">{jobData.title}</h4>
            <span className="px-3 py-1 bg-primary-100 text-primary rounded-full text-sm font-medium">
              {jobData.employment_type} • {jobData.remote_work}
            </span>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div>
              <span className="text-text-muted">Experience:</span>
              <p className="font-medium text-text-primary">
                {getExperienceLevelLabel(jobData.experience_level)}
              </p>
            </div>
            <div>
              <span className="text-text-muted">Location:</span>
              <p className="font-medium text-text-primary">{jobData.location}</p>
            </div>
            <div>
              <span className="text-text-muted">Salary:</span>
              <p className="font-medium text-text-primary">
                ${jobData.salary_min}-${jobData.salary_max}/{jobData.currency}
              </p>
            </div>
            <div>
              <span className="text-text-muted">Skills:</span>
              <p className="font-medium text-text-primary">
                {jobData.skills_required.length} required
              </p>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <p className="text-text-secondary text-sm line-clamp-3">
              {jobData.description}
            </p>
          </div>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="AlertTriangle" size={20} className="text-yellow-600 mt-0.5" />
            <div>
              <h4 className="font-medium text-yellow-800">Ready to publish?</h4>
              <p className="text-yellow-700 text-sm mt-1">
                Once published, your job will be visible to all Virtual Assistants on the
                platform. You can edit or pause the job anytime from your dashboard.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

Step4ReviewPublish.displayName = 'Step4ReviewPublish';
